import {
  Sidebar,
  Menu,
  MenuItem,
  useProSidebar,
  SubMenu,
} from "react-pro-sidebar";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import VideoCallOutlinedIcon from "@mui/icons-material/VideoCallOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MonitorIcon from "@mui/icons-material/Monitor";
import EngineeringIcon from "@mui/icons-material/Engineering";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import DeviceHubIcon from "@mui/icons-material/DeviceHub";
import SmsIcon from "@mui/icons-material/Sms";
import TocIcon from "@mui/icons-material/Toc";
import AddIcon from "@mui/icons-material/Add";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {
  useSignOut,
  useIsAuthenticated,
  useAuthUser,
  useAuthHeader,
} from "react-auth-kit";
import { useGetNotifications } from "./useNotifications";
import { useEffect, useState } from "react";
import { Badge } from "@mui/material";
import ConfirmSignoutDialog from "../ConfirmSignoutComponent/ConfirmSignout";
import { deviceCategories } from "../DeviceComponents";
import logo from "../../logos/health3000_logo.png";
import { prettify } from "../../utils/utils";

function AppSidebar() {
  const { collapseSidebar } = useProSidebar();
  const isAuthenticated = useIsAuthenticated();
  const authUser = useAuthUser();
  const authHeader = useAuthHeader();

  const signOut = useSignOut();
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const notificationsPolling = useGetNotifications(false);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    // show badge
    if (
      notificationsPolling?.data?.notifications !== undefined &&
      notificationsPolling?.data?.notifications !== notifications
    ) {
      setNotifications(notificationsPolling.data.notifications);
    }
  }, [notificationsPolling.isFetching]);

  const handleConfirmDialogOpen = () => {
    setConfirmDialogOpen(true);
  };
  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
  };

  const handleSignOut = () => {
    setConfirmDialogOpen(false);
    signOut();
  };

  useEffect(() => {
    if (isAuthenticated()) {
      setLoaded(true);
    }
    if (loaded && !isAuthenticated()) {
      navigate("/login");
    }
  }, [loaded, isAuthenticated()]);

  const conditionalRoleRendering = () => {
    // CONTROL ROOM
    if (authUser()?.role === 1) {
      return (
        <>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/controlroom" />}
            icon={<MonitorIcon />}
          >
            Control Room
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/patients" />}
            icon={<PeopleOutlinedIcon />}
          >
            Pazienti
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/doctors" />}
            icon={<EngineeringIcon />}
          >
            Professionisti Sanitari
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/telemonitoraggi" />}
            icon={<MonitorHeartIcon />}
          >
            Telemonitoraggi
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/televisite" />}
            icon={<VideoCallOutlinedIcon />}
          >
            Televisite
          </MenuItem>
          <SubMenu label="Dispositivi" icon={<DeviceHubIcon />}>
            {deviceCategories.map((el) => (
              <MenuItem
                key={crypto.randomUUID()}
                component={<Link to="/devices" state={{ filter: el }} />}
              >
                {prettify(el)}
              </MenuItem>
            ))}
            <MenuItem key={crypto.randomUUID()} component={<Link to="/h3kb" />}>
              Gateway
            </MenuItem>
          </SubMenu>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/monitoralert" />}
            icon={<EngineeringIcon />}
          >
            Monitor Alert
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/communications" />}
            icon={<SmsIcon />}
          >
            Comunicazioni
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/dailyreports" />}
            icon={<TocIcon />}
          >
            Daily Reports
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/profile" />}
            icon={
              <Badge
                color="error"
                badgeContent={
                  notifications.length > 0 ? notifications.length : null
                }
              >
                <PeopleOutlinedIcon />
              </Badge>
            }
          >
            Mio profilo
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/users" />}
            icon={<AddIcon />}
          >
            Gestione utenti
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/security" />}
            icon={<LockOutlinedIcon />}
          >
            Security
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            onClick={handleConfirmDialogOpen}
            icon={<LogoutOutlinedIcon />}
          >
            Logout ({authUser().user.first_name})
          </MenuItem>
        </>
      );
      // ADMIN STRUTTURA
    } else if (authUser()?.role === 2) {
      return (
        <>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/patients" />}
            icon={<PeopleOutlinedIcon />}
          >
            Pazienti
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/doctors" />}
            icon={<EngineeringIcon />}
          >
            Professionisti Sanitari
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/telemonitoraggi" />}
            icon={<MonitorHeartIcon />}
          >
            Telemonitoraggi
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/dailyreports" />}
            icon={<TocIcon />}
          >
            Daily Reports
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/users" />}
            icon={<AddIcon />}
          >
            Gestione utenti
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/security" />}
            icon={<LockOutlinedIcon />}
          >
            Security
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            onClick={handleConfirmDialogOpen}
            icon={<LogoutOutlinedIcon />}
          >
            Logout ({authUser().user.first_name})
          </MenuItem>
        </>
      );
      // PROF SANITARIO
    } else {
      return (
        <>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/patients" />}
            icon={<PeopleOutlinedIcon />}
          >
            Pazienti
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/televisite" />}
            icon={<VideoCallOutlinedIcon />}
          >
            Televisite
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/telemonitoraggi" />}
            icon={<MonitorHeartIcon />}
          >
            Telemonitoraggi
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/communications" />}
            icon={<SmsIcon />}
          >
            Comunicazioni
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/dailyreports" />}
            icon={<TocIcon />}
          >
            Daily Reports
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/profile" />}
            icon={<PeopleOutlinedIcon />}
          >
            Mio profilo
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/security" />}
            icon={<LockOutlinedIcon />}
          >
            Security
          </MenuItem>
          <MenuItem
            key={crypto.randomUUID()}
            onClick={handleConfirmDialogOpen}
            icon={<LogoutOutlinedIcon />}
          >
            Logout ({authUser().user.first_name})
          </MenuItem>
        </>
      );
    }
  };

  return (
    <>
      <ConfirmSignoutDialog
        open={confirmDialogOpen}
        handleCancel={handleConfirmDialogClose}
        handleConfirm={handleSignOut}
      />
      <Sidebar style={{ height: "100vh" }} defaultCollapsed={false}>
        <Menu>
          <MenuItem
            key={crypto.randomUUID()}
            icon={<MenuOutlinedIcon />}
            onClick={() => {
              collapseSidebar();
            }}
            style={{ textAlign: "center" }}
          >
            {" "}
            <img src={logo} alt="health3000 logo" style={{ width: "100%" }} />
          </MenuItem>

          <MenuItem
            key={crypto.randomUUID()}
            component={<Link to="/" />}
            icon={<HomeOutlinedIcon />}
          >
            Home
          </MenuItem>

          {isAuthenticated() ? (
            conditionalRoleRendering()
          ) : (
            <MenuItem
              key={crypto.randomUUID()}
              onClick={() => {
                collapseSidebar();
              }}
              component={<Link to="/login" />}
              icon={<LoginOutlinedIcon />}
            >
              Login
            </MenuItem>
          )}
        </Menu>
      </Sidebar>
    </>
  );
}

export default AppSidebar;
